import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBase from "./customFetchBase";

import {
  IBlogSaveDraft,
  IBlogSavePublish,
  IGenericResponse,
  IGetBlogs,
  IGetBlogsDet,
  IPromptAcceptSchema,
  IPromptRunSchema,
  IGenerateContent,
  IGetBlogsAdmin,
  ExtractDoc,
  IPrompt,
  IProductDet,
  IGenerateBusinessUrlBlogs,
  IGeturlGeneratedBlogs,
  IThumbsUp,
  IThumbsDown,
  IRegenerateBusinessUrlBlogs,
  ICopyShareUrl,
  IPublishToGoogle,
  IPublishedUnpublishedCount,
  IBulkBlogsPublish,
  IcampaignList,
  IepisodeList,
  IepisodeListSearch,
  IclipsList,
  IclipsListSearch,
  IimageList,
  IcreateCampaign,
  IGetPageForCampaign,
  ICnameEntry,
  IupdatingpublishFlag,
  Searchbyuserid,
  IProductHeadings,
  IGetKeywordTags,
  IGetBlogsByCampaign,
  Iverifyscript,
  IGetBlogGenerationStatus
} from "./types";
import { IPromptSchema } from "../../components/Prompt";
import { userApi } from "./userApi";
import { setComplexity } from "../features/genieSlice";
import { IBlogsUpdate, IGetBlogId, IDeleteBlog } from "./types";
import { BlogUpdate } from "../../pages/admin/blogedit.page";
// import { BlogDraft } from "../../pages/traffic_monster/generated_blogs";
import { BlogDraft } from "../../pages/admin/blogedit.page";
import { BlogPublish } from "../../pages/admin/blogedit.page";
import { GenerateCont } from "../../pages/admin/blogedit.page";
import { CreateBlog } from "pages/traffic_monster/dashboard_tm";

export const promptApi = createApi({
  reducerPath: "promptApi",
  baseQuery: customFetchBase,
  tagTypes: ["Prompt", "Products", "InitiatedPosts"],
  endpoints: (builder) => ({
    addPrompt: builder.mutation<IGenericResponse, IPromptSchema>({
      query(data) {
        return {
          url: "prompts",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: [{ type: "Prompt", id: "LIST" }],
    }),
    getPrompts: builder.query<IPromptAcceptSchema[], string | void>({

      query(product_id) {

        let url = 'prompts';
        if (product_id) {
          // If product_id is provided, add it as a query parameter
          url = `prompts?product_id=${product_id}`;
        }
        return {
          url,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IPromptAcceptSchema[] }) =>
        results.data,
      providesTags: [{ type: "Prompt", id: "LIST" }],
    }),
    updatePrompt: builder.mutation<
      IGenericResponse,
      { id: string; info: IPromptSchema }
    >({
      query({ id, info }) {
        return {
          url: `prompts/${id}`,
          method: "PATCH",
          body: info,
        };
      },
      invalidatesTags: [{ type: "Prompt", id: "LIST" }],
    }),

    getPromptNames: builder.query<
      string[],
      { product_name: string; product_module: string }
    >({
      query({ product_name, product_module }) {
        return {
          url: `prompts/names?product_name=${product_name}&product_module=${product_module}`,
        };
      },
      transformResponse: (results: { data: { prompt_name: string }[] }) =>
        results.data.map((item) => item.prompt_name),
    }),

    getPromptByProductId: builder.query<{ data: IPrompt[] }, { product_id: string }>({
      query({ product_id }) {
        return {
          url: `prompts/getPromptDet?product_id=${product_id}`,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IPrompt[] }) => ({ data: results.data }),
      providesTags: [{ type: "Prompt", id: "LIST" }],
    }),

    runPrompt: builder.mutation<Array<any>, IPromptRunSchema>({
      query(data) {
        return {
          url: "prompts/run",
          method: "POST",
          body: data,
        };
      },
      transformResponse: (results: { msg: Array<any> }) => results.msg,
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          await dispatch(userApi.endpoints.getMe.initiate(null));
          console.log(data);
          //dispatch(setComplexity(data));
        } catch (error) { }
      },
    }),
    getBlogDetails: builder.query<IGetBlogs[], { limitval: number; skipval: number; promptid?: string, userid?: string; domain: string }>({

      query({ limitval, skipval, promptid = "", userid = "", domain }) {
        console.log("herere...1");
        return {
          url: `prompts/listBlogsByUserID?limitval=${limitval}&skipval=${skipval}&promptid=${promptid}&userid=${userid}&domain=${domain}`,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IGetBlogs[] }) => results.data,
      providesTags: [{ type: "Prompt", id: "LIST" }],
    }),
    getBlogDetailsAdmin: builder.query<IGetBlogsAdmin[], { limitval: number; skipval: number, query: string }>({

      query({ limitval, skipval, query }) {
        console.log("herere...1");
        return {
          url: `prompts/listBlogsadmin?limitval=${limitval}&skipval=${skipval}&query=${query}`,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IGetBlogsAdmin[] }) => results.data,
      providesTags: [{ type: "Prompt", id: "LIST" }],
    }),
    getBlogDet: builder.query<{ data: IGetBlogsDet[]; nexturl: string; }, { url: string }>({
      query({ url }) {
        return {
          url: `prompts/getBlogDetbyURL?url=${url}`,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IGetBlogsDet[], nexturl: string }) => {
        // Simply return both data and nexturl
        return { data: results.data, nexturl: results.nexturl };

      },
      providesTags: [{ type: "Prompt", id: "LIST" }],
    }),

    getBlogid: builder.query<{ data: IGetBlogId[]; nexturl: string; }, { blog_id?: string; campId?: string; profile_id?: string; blog_url?: string }>({
      query({ blog_id, campId, profile_id, blog_url }) {

        const params = new URLSearchParams();
        if (blog_id) params.append("blog_id", blog_id);
        if (campId) params.append("campId", campId);
        if (profile_id) params.append("profile_id", profile_id);
        if (blog_url) params.append("blog_url", blog_url);

        return {
          url: `prompts/getBlogDet?${params.toString()}`,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IGetBlogId[], nexturl: string }) => {
        // Simply return both data and nexturl
        return { data: results.data, nexturl: results.nexturl };

      },
      providesTags: [{ type: "Prompt", id: "LIST" }],

    }),

    deleteBlog: builder.mutation<IDeleteBlog, { blog_id: string }>({
      query({ blog_id }) {
        return {
          url: `prompts/deleteBlog?blog_id=${blog_id}`,
          method: "GET",
        };
      },
    }),

    deletePodcast: builder.mutation<
      { status: string; message: string },
      { podcast_id: string }
    >({
      query({ podcast_id }) {
        return {
          url: `prompts/delete_podcast?podcast_id=${podcast_id}`,
          method: "POST",
        };
      },
      invalidatesTags: [{ type: "Prompt", id: "LIST" }],
    }),

    bulkDeletePodcast: builder.mutation<
      any,
      { podcast_ids: string[] }
    >({
      query: ({ podcast_ids }) => ({
        url: `prompts/delete_podcast_multiple?podcast_ids=${podcast_ids.join(",")}`,
        method: "POST",
      }),
      invalidatesTags: [{ type: "Prompt", id: "LIST" }],
    }),

    deleteClip: builder.mutation<
      { status: string; message: string },
      { clip_id: string }
    >({
      query({ clip_id }) {
        return {
          url: `prompts/delete_clip?clip_id=${clip_id}`,
          method: "POST",
        };
      },
      invalidatesTags: [{ type: "Prompt", id: "LIST" }],
    }),

    deleteMultipleClips: builder.mutation<
      { status: string; message: string },
      { clip_ids: string[] }
    >({
      query({ clip_ids }) {
        return {
          url: `prompts/delete_clip_multiple?clip_ids=${clip_ids.join(",")}`,
          method: "POST",
        };
      },
      invalidatesTags: [{ type: "Prompt", id: "LIST" }],
    }),

    deleteImage: builder.mutation<
      { status: string; message: string },
      { image_id: string }
    >({
      query({ image_id }) {
        return {
          url: `prompts/delete_image?image_id=${image_id}`,
          method: "POST",
        };
      },
      invalidatesTags: [{ type: "Prompt", id: "LIST" }],
    }),

    deleteImageMultiple: builder.mutation<
      any,
      { image_ids: string[] }
    >({
      query: ({ image_ids }) => ({
        url: `prompts/delete_image_multiple`,
        method: "POST",
        params: {
          image_ids: image_ids.join(","),
        },
      }),
    }),

    SearchbyUserid: builder.mutation<IProductHeadings, { userid: string, campaignid: string }>({
      query({ userid, campaignid }) {
        return {
          url: `prompts/searchbyuserid?userid=${userid}&campaignid=${campaignid}`,
          method: "GET",
        };
      },
    }),

    /* TafficMonster */
    /* generateBusinessBlog: builder.mutation<IGenerateBusinessUrlBlogs, { url: string, userid: string, tone: any, sourcemode: string, videoid: string, product_desc: string, media_file: string }>({
      query({url, userid, tone, sourcemode, videoid, product_desc, media_file}) {
        return {
          url: `prompts/get_page?url=${url}&userid=${userid}&tone=${tone}&sourcemode=${sourcemode}&videoid=${videoid}&product_desc=${product_desc}&media_file=${media_file}`,
          method: "POST",
        };
      },
    }), */

    generateBusinessBlog: builder.mutation<IGenerateBusinessUrlBlogs, CreateBlog>({
      query(data) {
        return {
          url: `prompts/get_page`,
          method: "POST",
          body: data,
        };
      },
    }),

    regenerateBusinessBlog: builder.mutation<IRegenerateBusinessUrlBlogs, { blog_id: string }>({
      query({ blog_id }) {
        return {
          url: `prompts/regenerateautoblogcontent?blog_id=${blog_id}`,
          method: "POST",
        };
      },
    }),

    generatedbusinessurlblogs: builder.mutation<IGeturlGeneratedBlogs, { userid: string, createddate: string, createddate_to: string }>({
      query({ userid, createddate, createddate_to }) {
        return {
          url: `prompts/listBlogsByUserID?userid=${userid}&createddate=${createddate}&createddate_to=${createddate_to}`,
          method: "GET",
        };
      },
    }),

    savingThumbsUp: builder.mutation<IThumbsUp, { blogid: string }>({
      query({ blogid }) {
        return {
          url: `prompts/blog_thums_up?blogid=${blogid}`,
          method: "GET",
        };
      },
    }),

    savingThumbsDown: builder.mutation<IThumbsDown, { blogid: string }>({
      query({ blogid }) {
        return {
          url: `prompts/blog_thums_down?blogid=${blogid}`,
          method: "GET",
        };
      },
    }),

    copyurl: builder.mutation<ICopyShareUrl, { blog_id: string }>({
      query({ blog_id }) {
        return {
          url: `prompts/generate_static_html?blog_id=${blog_id}`,
          method: "GET",
        };
      },
    }),

    publishtogoogle: builder.mutation<IPublishToGoogle, { blog_id: string, publish_to_ocesha: number, publish_to_code_genie: number }>({
      query({ blog_id, publish_to_ocesha, publish_to_code_genie }) {
        return {
          url: `prompts/publish_to_google?blog_id=${blog_id}&publish_to_ocesha=${publish_to_ocesha}&publish_to_code_genie=${publish_to_code_genie}`,
          method: "GET",
        };
      },
    }),

    publishUnpublishCount: builder.mutation<IPublishedUnpublishedCount, { email: string, campaignid: string }>({
      query({ email, campaignid }) {
        return {
          url: `prompts/get_published_and_unpublished_count_by_email?email=${email}&campaignid=${campaignid}`,
          method: "GET",
        };
      },
    }),

    publishBulkyBlogs: builder.mutation<IBulkBlogsPublish, { blog_ids: string }>({
      query({ blog_ids }) {
        return {
          url: `prompts/generate_static_html_bulk?blog_ids=${blog_ids}`,
          method: "GET",
        };
      },
    }),

    getgeneratedBlogListings: builder.query<IGetBlogsAdmin[], { promptid: string, userid: string, limitval: number, skipval: number }>({
      query({ promptid = "", userid, limitval, skipval }) {
        return {
          url: `prompts/listBlogsByUserID?promptid=${promptid}&userid=${userid}&limitval=${limitval}&skipval=${skipval}`,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IGetBlogsAdmin[] }) => results.data,
      providesTags: [{ type: "Prompt", id: "LIST" }],
    }),

    getBlogsByCampaign: builder.query<IGetBlogsAdmin[], { campaignid: string, limitval: number, skipval: number }>({
      query({ campaignid, limitval, skipval }) {
        return {
          url: `prompts/listBlogsByCampaignId?campaignid=${campaignid}&limitval=${limitval}&skipval=${skipval}`,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IGetBlogsAdmin[] }) => results.data,
      providesTags: [{ type: "Prompt", id: "LIST" }],
    }),

    getBlogsByCampaignstatus: builder.query<IGetBlogsAdmin[], { campaignid: string, limitval: number, skipval: number, status: string }>({
      query({ campaignid, limitval, skipval, status }) {
        return {
          url: `prompts/listBlogsByCampaignIdwithstatus?campaignid=${campaignid}&limitval=${limitval}&skipval=${skipval}&status=${status}`,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IGetBlogsAdmin[] }) => results.data,
      providesTags: [{ type: "Prompt", id: "LIST" }],
    }),

    getrandomBlogListings: builder.query<IGetBlogsAdmin[], {}>({
      query() {
        return {
          url: `prompts/listRandomBlogs`,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IGetBlogsAdmin[] }) => results.data,
      providesTags: [{ type: "Prompt", id: "LIST" }],
    }),


    getproductsDet: builder.query<IProductDet[], { user_id: string }>({
      query({ user_id }) {
        return {
          url: `prompts/getProducts?user_id=${user_id}`,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IProductDet[] }) => results.data,
      providesTags: [{ type: "Products", id: "LIST" }],
    }),

    campaignList: builder.mutation<IcampaignList, { email: string }>({
      query({ email }) {
        return {
          url: `prompts/list_campaigns?email=${email}`,
          method: "GET",
        };
      },
    }),

    createCampaign: builder.mutation<IcreateCampaign, { campaign_name: string, url: string, email: string, sourcemode: string, videoid: string, product_desc: string }>({
      query({ campaign_name, url, email, sourcemode, videoid, product_desc }) {
        return {
          url: `prompts/create_campaign?campaign_name=${campaign_name}&url=${url}&email=${email}&sourcemode=${sourcemode}&videoid=${videoid}&product_desc=${product_desc}`,
          method: "GET",
        };
      },
    }),

    getpagefrocampaign: builder.mutation<IGetPageForCampaign, { email: string, campaign_id: string, topic: string, keywords: string }>({
      query({ email, campaign_id, topic, keywords }) {
        return {
          url: `prompts/get_page_for_campaign?email=${email}&campaign_id=${campaign_id}&topic=${topic}&keywords=${keywords}`,
          method: "GET",
        };
      },
    }),

    getCnameEntries: builder.mutation<ICnameEntry, { email: string, campaignid: string }>({
      query({ email, campaignid }) {
        return {
          url: `prompts/getcnameentries?email=${email}&campaignid=${campaignid}`,
          method: "POST",
        };
      },
    }),

    getverifyscript: builder.mutation<Iverifyscript, { userid: string, campaingid: string }>({
      query({ userid, campaingid }) {
        return {
          url: `prompts/getVerifyScript?userid=${userid}&campaingid=${campaingid}`,
          method: "POST",
        };
      },
    }),

    checkverified: builder.mutation<Iverifyscript, { userid: string, campaingid: string }>({
      query({ userid, campaingid }) {
        return {
          url: `prompts/checkSiteVerfied?userid=${userid}&campaingid=${campaingid}`,
          method: "POST",
        };
      },
    }),

    updateAutoPublishFlag: builder.mutation<IupdatingpublishFlag, { campaign_id: string, autopublish: number, threeblogperday: number, addtags: number, capturleads: number, twitterurl: string, fburl: string, pintresturl: string, linkedinurl: string, newsletter: number, twitternbutton: number, fbbutton: number, pintrestbutton: number, linkedinbutton: number, video: number, owndomain: number, cta_lable: string, cta_link: string, videotag: string, iframe: number, publish_to_ocesha: number, publish_to_code_genie: number, competetor_search: number }>({
      query({ campaign_id, autopublish, threeblogperday, addtags, capturleads, twitterurl, fburl, pintresturl, linkedinurl, newsletter, twitternbutton, fbbutton, pintrestbutton, linkedinbutton, video, owndomain, cta_lable, cta_link, videotag, iframe, publish_to_ocesha, publish_to_code_genie, competetor_search }) {
        return {
          url: `prompts/update_auto_publish_flag?campaign_id=${campaign_id}&autopublish=${autopublish}&threeblogperday=${threeblogperday}&addtags=${addtags}&capturleads=${capturleads}&twitterurl=${encodeURIComponent(twitterurl)}&fburl=${encodeURIComponent(fburl)}&pintresturl=${encodeURIComponent(pintresturl)}&linkedinurl=${encodeURIComponent(linkedinurl)}&newsletter=${newsletter}&twitternbutton=${twitternbutton}&fbbutton=${fbbutton}&pintrestbutton=${pintrestbutton}&linkedinbutton=${linkedinbutton}&video=${video}&owndomain=${owndomain}&cta_lable=${cta_lable}&cta_link=${cta_link}&videotag=${videotag}&iframe=${iframe}&publish_to_ocesha=${publish_to_ocesha}&publish_to_code_genie=${publish_to_code_genie}&competetor_search=${competetor_search}`,
          method: "GET",
        };
      },
    }),

    getTagKeywords: builder.mutation<IGetKeywordTags, { campaignid: string, blogid: string }>({
      query({ campaignid, blogid }) {
        return {
          url: `prompts/getKeyWords?campaignid=${campaignid}&blogid=${blogid}`,
          method: "GET",
        };
      },
    }),

    getBlogGenerationStatus: builder.mutation<IGetBlogGenerationStatus, { campaignid: string }>({
      query({ campaignid }) {
        return {
          url: `prompts/checkBlogGenerationStatus?campaignid=${campaignid}`,
          method: "GET",
        };
      },
    }),

    /*  */

    BlogDetailsUpdate: builder.mutation<IBlogsUpdate[], BlogUpdate>({
      query(data) {
        return {
          url: "prompts/updateblog",
          method: "POST",
          body: data,
        };
      },
    }),

    BlogDetailsDraft: builder.mutation<IBlogSaveDraft, BlogDraft>({
      query(data) {
        return {
          url: "prompts/savecontentasdraft",
          method: "POST",
          body: data,
        };
      },
    }),

    BlogDetailsPublish: builder.mutation<IBlogSavePublish, BlogPublish>({
      query(data) {
        return {
          url: "prompts/publishcontent",
          method: "POST",
          body: data,
        };
      },
    }),

    GenerateBlogs: builder.mutation<IGenerateContent, { cat: string, title: string, prompt: string }>({
      query({ cat, title, prompt }) {
        return {
          url: `prompts/generatecontent?cat=${cat}&title=${title}&prompt=${prompt}`,
          method: "POST",
          /* body: data, */
        };
      },
    }),

    ExtractDoc: builder.mutation<ExtractDoc, { file: any, product_name: string, product_module: string, blog_count: number, seo_line: string }>({
      query(data) {
        return {
          url: "prompts/extractDoc",
          method: "POST",
          body: data,
        };
      },
    }),


    BlogsCount: builder.query<any, { promptid: string, userid: string, cat: string, query: string, domain: string }>({
      query({ promptid = "", userid, cat = "SMART CONTRACTS", query = "", domain }) {
        return {
          // url: `prompts/listBlogsCount?cat=${cat}&query=${query}`,
          url: `prompts/listBlogsCountByUserID?userid=${userid}&cat=${cat}&query=${query}&domain=${domain}&promptid=${promptid}`,
          method: "GET"
        };
      },
      transformResponse: (results: { data: any }) => results.data,
      providesTags: [{ type: 'Prompt', id: 'LIST' }],
    }),

    ImageListingsCount: builder.query<any, { userid: string, podcastId: string }>({
      query({ userid, podcastId }) {
        return {
          // url: `prompts/listBlogsCount?cat=${cat}&query=${query}`,
          url: `prompts/listImagesCountByUserID?userid=${userid}&podcastId=${podcastId}`,
          method: "GET"
        };
      },
      transformResponse: (results: { data: any }) => results.data,
      providesTags: [{ type: 'Prompt', id: 'LIST' }],
    }),


    EpisodeListingsCount: builder.query<
      any,
      { userid: string; search?: string; fromDate?: string | null; toDate?: string | null }
    >({
      query({ userid, search = "", fromDate, toDate }) {
        const params = new URLSearchParams({
          userid,
        });
        if (search) {
          params.append("searchstr", search);
        }
        if (fromDate) {
          params.append("fromdate", fromDate);
        }
        if (toDate) {
          params.append("todate", toDate);
        }
        return {
          url: `prompts/listEpisodesCountByUserID?${params.toString()}`,
          method: "GET"
        };
      },
      transformResponse: (results: { data: any }) => results.data,
      providesTags: [{ type: 'Prompt', id: 'LIST' }],
    }),

    getGeneratedEpisodeListings: builder.mutation<
      IepisodeList[],
      {
        email: string;
        limitval: number;
        skipval: number;
        search?: string;
        fromDate?: string | null;
        toDate?: string | null;
        source?: string | null;
        url?: string | null;
      }
    >({
      query({ email, limitval, skipval, search = "", fromDate, toDate }) {
        const params = new URLSearchParams({
          email,
          limitval: String(limitval),
          skipval: String(skipval),
          searchstr: search ?? "",
        });
        if (fromDate) {
          params.append("fromdate", fromDate);
        }
        if (toDate) {
          params.append("todate", toDate);
        }
        return {
          url: `prompts/list_episodes?${params.toString()}`,
          //url: `prompts/list_episodes_published?${params.toString()}`,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IepisodeList[] }) => results.data
    }),

    getGeneratedPublishEpisodeListings: builder.mutation<
          IepisodeList[],
          {
            email: string;
            limitval: number;
            skipval: number;
            search?: string;
            fromDate?: string | null;
            toDate?: string | null;
            source?: string | null;
            url?: string | null;
          }
        >({
          query({ email, limitval, skipval, search = "", fromDate, toDate }) {
            const params = new URLSearchParams({
              email,
              limitval: String(limitval),
              skipval: String(skipval),
              searchstr: search ?? "",
            });
            if (fromDate) {
              params.append("fromdate", fromDate);
            }
            if (toDate) {
              params.append("todate", toDate);
            }
            return {
              url: `prompts/list_episodes_published?${params.toString()}`,
              method: "GET",
            };
          },
          transformResponse: (results: { data: IepisodeList[] }) => results.data
        }),

    getGeneratedEpisodeListingsSearch: builder.mutation<IepisodeListSearch[], { email: string, search: string }>({
      query({ email, search }) {
        return {
          url: `prompts/list_episodes?email=${email}&searchstr=${search}`,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IepisodeListSearch[] }) => results.data
    }),


    ClipsListingsCount: builder.query<
      any,
      { userid: string; product_id?: string | null; search?: string; fromDate?: string | null; toDate?: string | null }
    >({
      query({ userid, product_id = "", search = "", fromDate, toDate }) {
        const params = new URLSearchParams({
          userid,
        });
        if (product_id) {
          params.append("product_id", product_id);
        }
        if (search) {
          params.append("searchstr", search);
        }
        if (fromDate) {
          params.append("fromdate", fromDate);
        }
        if (toDate) {
          params.append("todate", toDate);
        }
        return {
          url: `prompts/listClipsCountByUserID?${params.toString()}`,
          method: "GET"
        };
      },
      transformResponse: (results: { data: any }) => results.data,
      providesTags: [{ type: 'Prompt', id: 'LIST' }],
    }),

    getGeneratedClipsListings: builder.mutation<
      IclipsList[],
      {
        email: string;
        product_id: string,
        limitval: number;
        skipval: number;
        search?: string;
        fromDate?: string | null;
        toDate?: string | null;
      }
    >({
      query({ email, product_id = "", limitval, skipval, search = "", fromDate, toDate }) {
        const params = new URLSearchParams({
          email,
          product_id,
          limitval: String(limitval),
          skipval: String(skipval),
          searchstr: search ?? "",
        });
        if (fromDate) {
          params.append("fromdate", fromDate);
        }
        if (toDate) {
          params.append("todate", toDate);
        }
        return {
          url: `prompts/list_clips?${params.toString()}`,
          //url: `prompts/list_clips_published?${params.toString()}`,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IclipsList[] }) => results.data
    }),


    getGeneratedPublishClipsListings: builder.mutation<
      IclipsList[],
      {
        email: string;
        product_id: string,
        limitval: number;
        skipval: number;
        search?: string;
        fromDate?: string | null;
        toDate?: string | null;
      }
    >({
      query({ email, product_id = "", limitval, skipval, search = "", fromDate, toDate }) {
        const params = new URLSearchParams({
          email,
          product_id,
          limitval: String(limitval),
          skipval: String(skipval),
          searchstr: search ?? "",
        });
        if (fromDate) {
          params.append("fromdate", fromDate);
        }
        if (toDate) {
          params.append("todate", toDate);
        }
        return {
          url: `prompts/list_clips_published?${params.toString()}`,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IclipsList[] }) => results.data
    }),


    getGeneratedClipsListingsSearch: builder.mutation<IclipsListSearch[], { email: string, product_id: string, search: string }>({
      query({ email, product_id, search }) {
        return {
          url: `prompts/list_clips?email=${email}&product_id=${product_id},searchstr=${search}`,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IclipsListSearch[] }) => results.data
    }),


    getGeneratedImageListings: builder.mutation<IimageList[], { email: string, product_id: string, limitval: number, skipval: number }>({
      query({ email, product_id, limitval, skipval }) {
        return {
          url: `prompts/list_images?email=${email}&product_id=${product_id}&limitval=${limitval}&skipval=${skipval}`,
          //url: `prompts/list_images_published?email=${email}&product_id=${product_id}&limitval=${limitval}&skipval=${skipval}`,
          method: "GET",
        };
      },
      transformResponse: (results: { data: IimageList[] }) => results.data
    }),


    getGeneratedPublishImageListings: builder.mutation<IimageList[], { email: string, product_id: string, limitval: number, skipval: number }>({
          query({ email, product_id, limitval, skipval }) {
            return {
              url: `prompts/list_images_published?email=${email}&product_id=${product_id}&limitval=${limitval}&skipval=${skipval}`,
              method: "GET",
            };
          },
          transformResponse: (results: { data: IimageList[] }) => results.data
        }),


    campaignBlogsCount: builder.query<any, { campaignid: string, userid: string, cat: string, query: string, domain: string }>({
      query({ campaignid, userid, cat = "SMART CONTRACTS", query = "", domain }) {
        return {
          url: `prompts/listBlogsCount?cat=${cat}&query=${query}`,
          //url: `prompts/listBlogsCountByCampignID?campaignid=${campaignid}&userid=${userid}&cat=${cat}&query=${query}&domain=${domain}`,
          method: "GET"
        };
      },
      transformResponse: (results: { data: any }) => results.data,
      providesTags: [{ type: 'Prompt', id: 'LIST' }],
    }),

    authorityEngineSuggestions: builder.query({
      query: (email: string) => ({
        url: `prompts/authority_engine_suggestions?user_email=${email}`,
        method: "GET",
      }),
    }),    
 
    genericEngineSuggestionsTrigger: builder.query<
      { result: string; task_id: string },
      { user_email: string; unsplash_access_key?: string, digital_twin_prompt?: string, knowledge_mode?: string }
    >({
      query: ({ user_email, unsplash_access_key = "", digital_twin_prompt , knowledge_mode }) => ({
        url: `prompts/authority_engine_suggestions_trigger`,
        method: "GET",
        params: {
          user_email,
          unsplash_access_key,
          result_count: 2,
          digital_twin_prompt,
          knowledge_mode,
          mode: "recommend",
          content_types: JSON.stringify([]),
        },
      }),
    }),

    authorityEngineSuggestionsTrigger: builder.mutation<
      { result: string; task_id: string },
      {
        user_email: string;
        unsplash_access_key?: string;
        digital_twin_prompt?: string;
        mode?: "recommend" | "recommend_generate";
        content_types?: { type: string; quantity: number }[];
        knowledge_mode?: "faithful" | "balanced" | "expanded";
      }
    >({
      query: ({ user_email, unsplash_access_key = "", digital_twin_prompt, mode, content_types, knowledge_mode, }) => ({
        url: `prompts/authority_engine_suggestions_trigger`,
        method: "GET",
        params: {
          user_email,
          unsplash_access_key,
          result_count: 2,
          digital_twin_prompt,
          ...(mode ? { mode } : {}),
          ...(knowledge_mode ? { knowledge_mode } : {}),
          // This endpoint sends args as GET query params, which can't carry a
          // nested array directly — JSON-stringify it so it survives the
          // querystring, and have the backend JSON.parse() it on receipt.
          // If/when this moves to a POST body, drop the stringify and just
          // pass `content_types` through as-is.
          ...(content_types ? { content_types: JSON.stringify(content_types) } : {}),
        },
      }),
    }),

    getTaskStatus: builder.query<
      { state: string; result?: any },
      string
    >({
      query: (task_id) => ({
        url: `prompts/task_status?task_id=${task_id}`,
        method: "GET",
      }),
    }),

    getBlogSuggestions: builder.query({
      query: (email) => ({
        url: "prompts/blog_suggestions",
        method: "POST",
        body: { user_email: email },
      }),
    }),

    getVideoSuggestions: builder.query({
      query: (email) => ({
        url: "prompts/video_suggestions",
        method: "POST",
        body: { user_email: email },
      }),
    }),

    getVideoSuggestionsTrigger: builder.query({
      query: ({ email, digital_twin_prompt, knowledge_mode }: { email: string, digital_twin_prompt: string, knowledge_mode: string }) => ({
        url: "prompts/process_video_suggestions_trigger",
        method: "POST",
        body: {
          user_email: email,
          video_id: "",
          result_count: 2,
          digital_twin_prompt: digital_twin_prompt || "",
          knowledge_mode,
        },
      }),
    }),

    getNewBlogSuggestionsTrigger: builder.query({
      query: ({ user_email }: { user_email: string }) => ({
        url: "prompts/process_create_new_blog_suggestions_trigger",
        method: "POST",
        body: {
          user_email: user_email,
        },
      }),
    }),


    getBlogSuggestionsTrigger: builder.query({
      query: ({ user_email }: { user_email: string }) => ({
        url: "prompts/process_blog_suggestions_trigger",
        method: "POST",
        body: {
          user_email: user_email,
        },
      }),
    }),




    getCourseSuggestions: builder.query({
      query: (email) => ({
        url: "prompts/course_suggestions",
        method: "POST",
        body: { user_email: email },
      }),
    }),

    generatePost: builder.mutation({
      query: ({ email, suggestion }) => ({
        url: `prompts/api/posts/generate?user_email=${email}`,
        method: "POST",
        body: {
          suggestion,
        },
      }),
    }),

    getInitiatedPosts: builder.query({
      query: ({ email, page = 1, limit = 10 }) => ({
        url: `prompts/api/posts/initiated?page=${page}&limit=${limit}&user_email=${email}`,
        method: "GET",
      }),
      providesTags: ["InitiatedPosts"],
    }),

    activatePost: builder.mutation({
      query: ({ postId, email }) => ({
        url: `prompts/api/posts/${postId}/activate?user_email=${email}`,
        method: "POST",
      }),
    }),

    updatePost: builder.mutation({
      query: ({ postId, content, platform, scheduleTime, imageUrl, url, video_url }) => ({
        url: `socialmedia/api/posts/${postId}/update`,
        method: "POST",
        body: {
          content,
          platform,
          scheduleTime,
          imageUrl,
          url,
          video_url,
        },
      }),

      invalidatesTags: ["InitiatedPosts"], // refresh list automatically
    }),

    schedulePost: builder.mutation({
      query: ({ postId, email, schedule_time }) => ({
        url: `prompts/api/posts/${postId}/schedule?user_email=${email}`,
        method: "POST",
        body: {
          schedule_time,
        },
      }),

      invalidatesTags: ["InitiatedPosts"], // refresh list
    }),

    getPlatformStatusCount: builder.query<any, string>({
      query: (email) =>
        `socialmedia/posts/count-by-platform-status/${email}`,
    }),

    processMultipleBlogSuggestionsTrigger: builder.mutation<
      any,
      {
        user_email: string;
        blog_ids: string;
      }
    >({
      query: ({ user_email, blog_ids }) => ({
        url: "prompts/process_multiple_blog_suggestions_trigger",
        method: "POST",
        body: {
          user_email,
          blog_ids,
        },
      }),
    }),

  }),
});

export const {
  useAddPromptMutation,
  useGetPromptsQuery,
  useGetPromptByProductIdQuery,
  useUpdatePromptMutation,
  useGetPromptNamesQuery,
  useRunPromptMutation,
  useGetBlogDetailsQuery,
  useGetBlogDetailsAdminQuery,
  useGetBlogDetQuery,
  useBlogDetailsUpdateMutation,
  useBlogDetailsDraftMutation,
  useBlogDetailsPublishMutation,
  useGenerateBlogsMutation,
  useBlogsCountQuery,
  useGetBlogidQuery,
  useImageListingsCountQuery,
  useEpisodeListingsCountQuery,
  useClipsListingsCountQuery,
  useDeleteBlogMutation,
  useDeletePodcastMutation,
  useBulkDeletePodcastMutation,
  useDeleteClipMutation,
  useDeleteMultipleClipsMutation,
  useDeleteImageMutation,
  useDeleteImageMultipleMutation,
  useSearchbyUseridMutation,
  useExtractDocMutation,
  useGenerateBusinessBlogMutation,
  useGeneratedbusinessurlblogsMutation,
  useGetgeneratedBlogListingsQuery,
  useGetBlogsByCampaignQuery,
  useGetproductsDetQuery,
  useSavingThumbsUpMutation,
  useSavingThumbsDownMutation,
  useRegenerateBusinessBlogMutation,
  useCopyurlMutation,
  usePublishUnpublishCountMutation,
  usePublishBulkyBlogsMutation,
  useGetrandomBlogListingsQuery,
  useCampaignListMutation,
  useCreateCampaignMutation,
  useGetpagefrocampaignMutation,
  useGetCnameEntriesMutation,
  useUpdateAutoPublishFlagMutation,
  useGetTagKeywordsMutation,
  useGetverifyscriptMutation,
  useCheckverifiedMutation,
  useGetBlogGenerationStatusMutation,
  useCampaignBlogsCountQuery,
  useGetBlogsByCampaignstatusQuery,
  usePublishtogoogleMutation,
  useGetGeneratedEpisodeListingsMutation,
  useGetGeneratedPublishEpisodeListingsMutation,
  useGetGeneratedClipsListingsMutation,
  useGetGeneratedPublishClipsListingsMutation,
  useGetGeneratedImageListingsMutation,
  useGetGeneratedPublishImageListingsMutation,
  useGetGeneratedEpisodeListingsSearchMutation,
  useGetGeneratedClipsListingsSearchMutation,
  useAuthorityEngineSuggestionsQuery,
  useGetBlogSuggestionsQuery,
  useGetVideoSuggestionsQuery,
  useGetVideoSuggestionsTriggerQuery,
  useGetCourseSuggestionsQuery,
  useGeneratePostMutation,
  useGetInitiatedPostsQuery,
  useActivatePostMutation,
  useUpdatePostMutation,
  useSchedulePostMutation,
  useGetPlatformStatusCountQuery,
  useAuthorityEngineSuggestionsTriggerMutation,
  useGetBlogSuggestionsTriggerQuery,
  useLazyGetTaskStatusQuery,
  useGetNewBlogSuggestionsTriggerQuery,
  useGenericEngineSuggestionsTriggerQuery,
  useProcessMultipleBlogSuggestionsTriggerMutation,
} = promptApi;
